export const EMAIL_PREFIX = "@gmail.com";
export const ERROR_MESSAGE = "Įvyko klaida";


// WEBPACK FOOTER //
// ./src/constants/common.js